<!--
    start content — the positioning context of the overlay, so the veil is
    centered on the projected block rather than on the host box.
-->
<div class="empty_overlay_content">

    <!--
        start body — the blur lives here and not on the wrapper above,
        because `filter` applies to descendants and creates a containing
        block: an overlay inside a blurred element would be blurred with
        it and would position against it.
    -->
    <div
        #contentHost
        class="empty_overlay_body"
        [class.is_blurred]="isEmpty()"
        [style.--empty-overlay-blur]="blur()"
        [attr.aria-hidden]="isEmpty() ? 'true' : null"
    >
        <ng-content />
    </div>

    @if (isEmpty()) {

        <!-- start overlay -->
        <div class="empty_overlay_veil">
            @let message = getTemplate('messageTemplate');
            @if (message; as tmpl) {
                <ng-container *ngTemplateOutlet="tmpl.templateRef; context: tmpl.context" />
            } @else {
                <span class="empty_overlay_text">{{ messageKey() | translate }}</span>
            }
        </div>

    }

</div>
